import React from 'react';
import EditorChrome from './EditorChrome';
import {githubProjects} from '../Content/PortfolioContent';

const GitHubProjects = () => (
    <main className="container portfolio-shell inner-shell">
        <EditorChrome active="/GitHub" />
        <section className="inner-editor">
            <a className="back-link" href="/">Back to homepage</a>
            <div className="page-heading">
                <p>;; Research code, embedded audio, and signal tools</p>
                <h1>GitHub Projects</h1>
                <span>Selected repositories with direct links to source code.</span>
            </div>
            <div className="repository-list">
                {githubProjects.map((project, index) => (
                    <a className="repository-row" href={project.url} target="_blank" rel="noreferrer" key={project.title}>
                        <span className="repo-index">{String(index + 1).padStart(2, '0')}</span>
                        <div>
                            <div className="repo-title"><h2>{project.title}</h2><span>↗</span></div>
                            <p>{project.description}</p>
                            <div className="repo-meta"><span>{project.meta}</span><span>{project.updated}</span></div>
                        </div>
                    </a>
                ))}
            </div>
            <a className="all-repositories" href="https://github.com/MilanMarocchi?tab=repositories" target="_blank" rel="noreferrer">View all repositories on GitHub ↗</a>
        </section>
    </main>
);

export default GitHubProjects;
